import React, { Component } from "react";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { blue, grey } from '@material-ui/core/colors';
import CustomizedCheckbox from "../common/StyledSmallCheckBox"

const BlueUserCheckBox = withStyles({
  root: {
    color: grey[300],
    '&$checked': {
      color: blue[600],
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

export default class UserCheckBox extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      userId: this.props.userId,
      label: this.props.label,
      value: this.props.value,
      isChecked : this.props.isChecked
    }
  }

  handleChange(event) {
   // console.log("handleChange" + event.target.checked);
   this.setState({isChecked:event.target.checked})
    this.props.onCheckChanged(this.props.userId, event.target.checked);
  }

 
  render() {
    return (
      <FormControlLabel
        control={
          <CustomizedCheckbox
            checked={this.state.isChecked}
            onChange={this.handleChange}
            value={this.state.value}
         />
        }
        label={this.state.label}
      />
    )
  }

 /* render() {
    return (
      <FormControlLabel
        control={
          <BlueUserCheckBox
          checked={this.state.isChecked}
            onChange={this.handleChange}
            value={this.state.value}
          />
        }
        label={this.state.label}
      />
    )
  }*/
}